var v = function() {
  var e, r, o = new Promise(function(t, n) {
    e = t, r = n;
  });
  return {
    resolve: e,
    reject: r,
    promise: o
  };
};
export {
  v as createDeferred
};
//# sourceMappingURL=index34.js.map
